module.exports = __webpack_public_path__ + "img/w13-b3.cbeabc9f.jpg";